// src/pages/DynamicComplexInputs/PersonWithDisability.jsx

import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Modal, Button, Badge, Table } from "react-bootstrap";
import Select from "react-select";
import { FaCheckCircle, FaPlus } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import waringSign from "../../assets/images/warnOmc.png";
import pdfIcon from "../../assets/images/pdf-icon.png"; // Ensure you have a PDF icon image=
import { AWSUpload } from "../../Upload/awsupload";
const PersonWithDisability = ({
  allowedPwbdType,
  handelApplicationDetailsChange,
  applicationDetails,
  style,
}) => {
  const [formData, setFormData] = useState({
    benchmarkDisability: applicationDetails?.benchmarkDisability || "",
    disabilityType: applicationDetails?.disabilityType || [],
    disabilityPercentage: applicationDetails?.disabilityPercentage || "",
    // disabilityTypewantScribe:
    //   applicationDetails?.disabilityTypewantScribe || "",
    // disabilityTypephysicalLimitation:
    //   applicationDetails?.disabilityTypephysicalLimitation || "",
    category: applicationDetails?.category || "",
    // pwbdDeclaration: applicationDetails?.pwbdDeclaration || "",
    disabilityFiles: applicationDetails?.disabilityFiles || [
      { file: null, name: "", verified: false },
    ], // Array of files
  });

  const [fieldErrors, setFieldErrors] = useState({});
  const [disabilityTypeOptions, setDisabilityTypeOptions] = useState([]);
  const [showIframe, setShowIframe] = useState(null); // To track which file's iframe to show

  // Options for select fields
  const options = {
    benchmarkDisabilityTypes: [
      { value: "TypeA", label: "Type A" },
      { value: "TypeB", label: "Type B" },
    ],
    disabilityPercentages: [
      { value: "40%", label: "40%" },
      { value: "50%", label: "50%" },
      { value: "60%", label: "60%" },
      { value: "70%", label: "70%" },
      { value: "80%", label: "80%" },
      { value: "90%", label: "90%" },
      { value: "100%", label: "100%" },
    ],
    yesNoOptions: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
  };

  const disabilityData = {
    categories: allowedPwbdType?.map((item) => ({
      label: item.Category,
      value: item.Category,
      disabilities: item.TypesOfDisabilities,
    })),
  };

  useEffect(() => {
    if (applicationDetails) {
      setFormData((prevData) => ({
        ...prevData,
        ...applicationDetails,
      }));
    }
  }, []);

  useEffect(() => {
    handelApplicationDetailsChange(formData);
  }, [formData]);

  // Handle general input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    setFormData((prevData) => {
      if (name === "benchmarkDisability" && value == "No") {
        return {
          benchmarkDisability: value,
          disabilityType: [],
          disabilityPercentage: "",
          // disabilityTypewantScribe: "",
          // disabilityTypephysicalLimitation: "",
          category: "",
          // pwbdDeclaration: "",
          disabilityFiles: [], // Array of files
        };
      } else if (name === "category") {
        // Handle multi-select by mapping selected options
        const selectedCategories = Array.from(options)
          .filter((option) => option.selected)
          .map((option) => option.value);

        return { ...prevData, category: selectedCategories };
      } else {
        // If "disabilityTypewantScribe" changes to "No", reset "disabilityTypephysicalLimitation"
        // if (name === "disabilityTypewantScribe" && value === "No") {
        //   return {
        //     ...prevData,
        //     [name]: value,
        //     // disabilityTypephysicalLimitation: "",
        //   };
        // }
        return { ...prevData, [name]: type === "checkbox" ? checked : value };
      }
    });
  };

  // Handle category change to update disability types
  const handleCategoryChange = (selectedOption) => {
    const selectedCategory = selectedOption ? selectedOption.value : "";
    setFormData((prevData) => ({ ...prevData, category: selectedCategory }));

    // Update disability types based on the selected category
    const selectedCategoryData = disabilityData?.categories?.find(
      (item) => item.value === selectedCategory
    );
    if (selectedCategoryData) {
      setDisabilityTypeOptions(
        selectedCategoryData?.disabilities?.map((disability) => ({
          label: disability,
          value: disability,
        }))
      );
    } else {
      setDisabilityTypeOptions([]);
    }

    // Check for errors after selection
    checkErrorFn("category", selectedCategory);
  };

  const categories = useMemo(
    () => disabilityData?.categories || [],
    [disabilityData]
  );

  useEffect(() => {
    if (formData?.category) {
      const selectedCategoryData = categories.find(
        (item) => item.value === formData?.category
      );
      if (selectedCategoryData) {
        setDisabilityTypeOptions(
          selectedCategoryData?.disabilities?.map((disability) => ({
            label: disability,
            value: disability,
          }))
        );
      } else {
        setDisabilityTypeOptions([]);
      }
    }
  }, []);

  // Validation function
  const checkErrorFn = async (fieldName, immediateValue, index = null) => {
    let errCount = 0;
    console.log(fieldName , "---------filed Name is required------------");
    setFieldErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (
        !immediateValue ||
        (Array.isArray(immediateValue) && immediateValue.length === 0)
      ) {
        errCount++;
        const errorMessage = "This field is required.";
        if (index !== null) {
          newErrors[`${fieldName}_${index}`] = {
            errors: [...new Set([errorMessage])],
            touched: true,
          };
        } else {
          newErrors[fieldName] = {
            errors: [...new Set([errorMessage])],
            touched: true,
          };
        }
      } else {
        switch (fieldName) {
          case "category":
            if (
              !immediateValue ||
              (Array.isArray(immediateValue) && immediateValue.length === 0)
            ) {
              errCount++;
              newErrors[fieldName] = {
                errors: [...new Set(["Invalid category."])],
                touched: true,
              };
            }
            break;

          case "disabilityType":
            if (immediateValue.length <= 0) {
              errCount++;
              newErrors[fieldName] = {
                errors: [...new Set(["Invalid disability type."])],
                touched: true,
              };
            }
            break;

          case "disabilityPercentage":
            const percentage = Number(immediateValue.replace("%", ""));
            if (isNaN(percentage) || percentage < 40 || percentage > 100) {
              errCount++;
              newErrors[fieldName] = {
                errors: [
                  ...new Set([
                    "Disability percentage must be between 40 and 100.",
                  ]),
                ],
                touched: true,
              };
            }
            break;

          // case "disabilityTypewantScribe":
          //   if (
          //     !options.yesNoOptions.some(
          //       (option) => option.value === immediateValue
          //     )
          //   ) {
          //     errCount++;
          //     newErrors[fieldName] = {
          //       errors: [...new Set(["Invalid selection."])],
          //       touched: true,
          //     };
          //   }
          //   break;

          // case "disabilityTypephysicalLimitation":
          //   if (formData.disabilityTypewantScribe === "Yes") {
          //     if (
          //       !options.yesNoOptions.some(
          //         (option) => option.value === immediateValue
          //       )
          //     ) {
          //       errCount++;
          //       newErrors[fieldName] = {
          //         errors: [...new Set(["Invalid selection."])],
          //         touched: true,
          //       };
          //     }
          //   }
          //   break;

          // case "pwbdDeclaration":
          //   if (!immediateValue) {
          //     errCount++;
          //     newErrors[fieldName] = {
          //       errors: [...new Set(["Please confirm this."])],
          //       touched: true,
          //     };
          //   }
            break;
            case "disabilityFile":
              if (!immediateValue) {
                errCount++;
                if (index !== null) {
                  newErrors[`disabilityFile_${index}`] = {
                    errors: [...new Set(["NO file choosen"])],
                    touched: true,
                  };
                }
              }
              break;
            
            
            case "disabilityFileName":
            console.log();
            if (immediateValue.trim() === "") {
              errCount++;
              if (index !== null) {
                newErrors[`disabilityFileName_${index}`] = {
                  errors: [...new Set(["File name cannot be empty."])],
                  touched: true,
                };
              }
            }
            break;

          default:
            break;
        }
      }

      if (errCount < 1) {
        if (index !== null) {
          newErrors[`${fieldName}_${index}`] = {
            errors: [],
            touched: true,
          };
        } else {
          newErrors[fieldName] = {
            errors: [],
            touched: true,
          };
        }
      }

      return newErrors;
    });
  };

  // Handler for adding a new file
  const addFile = () => {
    setFormData((prevData) => ({
      ...prevData,
      disabilityFiles: [
        ...prevData.disabilityFiles,
        { file: null, name: "", verified: false },
      ],
    }));
  };

  // Handler for removing a file
  const removeFile = (index) => {
    const updatedFiles = [...formData.disabilityFiles];
    updatedFiles.splice(index, 1);
    setFormData((prevData) => ({
      ...prevData,
      disabilityFiles: updatedFiles,
    }));
    // Remove any associated errors
    const updatedErrors = { ...fieldErrors };
    delete updatedErrors[`disabilityFileName_${index}`];
    delete updatedErrors[`disabilityFile_${index}`];
    setFieldErrors(updatedErrors);
  };

  // Handler for file input change
  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    if (!file) {
       checkErrorFn("disabilityFile", null, index);
      return;
    }
    if (file) {

      const isPDF = file.type === "application/pdf";
    
      if (!isPDF) {
        toast.warn("Invalid file type. Only PDF files are allowed.");
        return;
      }
    
      const fileUrl = await AWSUpload(file); // Assuming UploadPdf returns a URL
      if (fileUrl) {
        const updatedFiles = [...formData.disabilityFiles];
        updatedFiles[index] = {
          ...updatedFiles[index],
          file: fileUrl,
          verified: false,
        };
        setFormData((prevData) => ({
          ...prevData,
          disabilityFiles: updatedFiles,
        }));
        // Reset verification status
      
      }
    }
  };

  // Handler for name input change
  const handleFileNameChange = (e, index) => {
    const { value } = e.target;
    const updatedFiles = [...formData.disabilityFiles];
    updatedFiles[index].name = value;
    setFormData((prevData) => ({
      ...prevData,
      disabilityFiles: updatedFiles,
    }));
    checkErrorFn("disabilityFileName", value, index);
  };

  // Handler to open the iframe modal for verification
  const handleOpenVerificationModal = (index) => {
    setShowIframe(index);
  };

  // Handler to confirm verification
  const handleConfirmVerification = () => {
    if (showIframe !== null) {
      const updatedFiles = [...formData.disabilityFiles];
      updatedFiles[showIframe].verified = true;
      setFormData((prevData) => ({
        ...prevData,
        disabilityFiles: updatedFiles,
      }));
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        [`disabilityFile_${showIframe}`]: {
          errors: [],
          touched: true,
        },
      }));
      setShowIframe(null); // Close the modal after verification
      toast.success("File verified successfully!");
    }
  };

  return (
    <>
      <Row>
        <Col xs={12} md={12}>
          <div
            style={{
              fontFamily: "'Roboto', sans-serif",
              color: "brown",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            <ol style={{ marginTop: "16px" }}>
              <li>
                1. If Percentage of Benchmark Disability is below 40%, then age
                and fee relaxation will not be applicable.
              </li>
              <li>
                2. By clicking on "Yes" below and submitting the information
                regarding disability, the applicant confirms that he/she
                fulfills the physical requirement as laid down in the
                advertisement.
              </li>
              <li>
                3. In case of detection of any discrepancy in this regard, the
                candidature for the applied post is liable to be cancelled at
                any stage of recruitment.
              </li>
              <li>4. PwBD Category Description</li>
            </ol>
          </div>
        </Col>

        {/* Hover Effect (Optional) */}
        <Col xs={12} md={12}>
          <div
            style={{
              backgroundColor: "white",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "15px",
              zIndex: 100,
              border: "1px solid #ccc",
              borderRadius: "5px",
              width: "400px",
              top: "30px",
              fontFamily: "'Roboto', sans-serif",
            }}
          >
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Category I(a)</td>
                  <td>LV</td>
                </tr>
                <tr>
                  <td>Category II(b)</td>
                  <td>HH, D</td>
                </tr>
                <tr>
                  <td>Category III(c)</td>
                  <td>OA, OL, BA, BL, LC, DW, AAV</td>
                </tr>
                <tr>
                  <td>Category IV(d,e)</td>
                  <td>ASD, MI, SLD, MD involving a to d</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>

        {/* Benchmark Disability Selection */}
        <Col xs={12} md={6}>
          <div className="mb-1">
            <label className="form-label inputBoxHeadForm" style={style.label}>
              Are You a Person with Benchmark disability (40% or more)?
              <span className="mx-1 text-danger">*</span>
            </label>
            <select
              name="benchmarkDisability"
              value={formData.benchmarkDisability}
              onChange={(e) => {
                handleInputChange(e);
                checkErrorFn("benchmarkDisability", e.target.value);
              }}
              onBlur={() =>
                checkErrorFn(
                  "benchmarkDisability",
                  formData["benchmarkDisability"]
                )
              }
              required
              style={
                fieldErrors?.["benchmarkDisability"]?.errors?.length > 0 &&
                fieldErrors?.["benchmarkDisability"]?.touched
                  ? { ...style.input, ...style.errorBox }
                  : style.input
              }
            >
              <option value="">Select</option>
              {options?.yesNoOptions?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {fieldErrors?.["benchmarkDisability"]?.errors?.length > 0 &&
              fieldErrors?.["benchmarkDisability"]?.touched &&
              fieldErrors?.["benchmarkDisability"]?.errors.map((err, idx) => (
                <span
                  key={idx}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {err}
                  <br />
                </span>
              ))}
          </div>
        </Col>

        {/* Conditional Fields if Benchmark Disability is Yes */}
        {formData.benchmarkDisability === "Yes" && (
          <>
            {/* Category Selection */}
            <Col xs={12} md={6}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  style={style.label}
                >
                  Category<span className="mx-1 text-danger">*</span>
                </label>
                <Select
                  name="category"
                  id="category"
                  className="react-select"
                  value={
                    disabilityData?.categories?.find(
                      (cat) => cat.value === formData.category
                    ) || ""
                  }
                  onChange={handleCategoryChange}
                  onBlur={() => checkErrorFn("category", formData["category"])}
                  options={disabilityData.categories}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "35px", // Set the height of the control
                      minHeight: "35px", // Match minimum height
                      ...(fieldErrors?.["category"]?.errors?.length > 0 &&
                        fieldErrors?.["category"]?.touched &&
                        style.errorBox),
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "35px", // Adjust the height of the value container
                      padding: "0px", // Remove extra padding
                    }),
                    input: (base) => ({
                      ...base,
                      height: "35px", // Set the height of the input field
                      margin: "0px", // Remove margins
                      padding: "0px", // Remove padding
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "35px", // Match the height of the indicators
                    }),
                  }}
                />

                {fieldErrors?.["category"]?.errors?.length > 0 &&
                  fieldErrors?.["category"]?.touched &&
                  fieldErrors?.["category"]?.errors.map((err, idx) => (
                    <span
                      key={idx}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </div>
            </Col>

            {/* Disability Type Selection */}

            <Col xs={12} md={6}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  style={style.label}
                >
                  Disability Type<span className="mx-1 text-danger">*</span>
                </label>
                <Select
                  name="disabilityType"
                  classNamePrefix="react-select"
                  className="react-select m-0 p-0"
                  isMulti
                  value={disabilityTypeOptions.filter((option) =>
                    formData.disabilityType.includes(option.value)
                  )}
                  onChange={(selectedOptions) => {
                    const values = selectedOptions
                      ? selectedOptions.map((option) => option.value)
                      : [];
                    setFormData((prevData) => ({
                      ...prevData,
                      disabilityType: values,
                    }));
                    checkErrorFn("disabilityType", values);
                  }}
                  onBlur={() =>
                    checkErrorFn("disabilityType", formData.disabilityType)
                  }
                  options={disabilityTypeOptions}
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "35px", // Set the height of the control
                      minHeight: "35px", // Match minimum height
                      ...(fieldErrors?.["disabilityType"]?.errors?.length > 0 &&
                        fieldErrors?.["disabilityType"]?.touched &&
                        style.errorBox),
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "35px", // Adjust the height of the value container
                      padding: "0px", // Remove extra padding
                    }),
                    input: (base) => ({
                      ...base,
                      height: "35px", // Set the height of the input field
                      margin: "0px", // Remove margins
                      padding: "0px", // Remove padding
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "35px", // Match the height of the indicators
                    }),
                  }}
                />

                {fieldErrors?.["disabilityType"]?.errors?.length > 0 &&
                  fieldErrors?.["disabilityType"]?.touched &&
                  fieldErrors?.["disabilityType"]?.errors.map((err) => (
                    <span className="errorPresent" style={style.errorSpan}>
                      {err}
                      <br />
                    </span>
                  ))}
              </div>
            </Col>

            {/* Disability Percentage Input */}
            <Col xs={12} md={6}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  style={style.label}
                >
                  Percentage of Disability
                  <span className="mx-1 text-danger">*</span>
                </label>
                <input
                  type="number"
                  id="Percentage_of_disability"
                  name="disabilityPercentage"
                  value={formData.disabilityPercentage}
                  onChange={(e) => {
                    handleInputChange(e);
                    checkErrorFn("disabilityPercentage", e.target.value);
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "disabilityPercentage",
                      formData["disabilityPercentage"]
                    )
                  }
                  min="40"
                  max="100"
                  required
                  style={
                    fieldErrors?.["disabilityPercentage"]?.errors?.length > 0 &&
                    fieldErrors?.["disabilityPercentage"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                />
                {fieldErrors?.["disabilityPercentage"]?.errors?.length > 0 &&
                  fieldErrors?.["disabilityPercentage"]?.touched &&
                  fieldErrors?.["disabilityPercentage"]?.errors.map(
                    (err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col>

            {/* Do You Want a Scribe? Selection */}
            {/* <Col xs={12} md={6}>
              <div className="mb-1">
                <label
                  className="form-label inputBoxHeadForm"
                  style={style.label}
                >
                  Do You Want a Scribe?
                  <span className="mx-1 text-danger">*</span>
                </label>
                <select
                  name="disabilityTypewantScribe"
                  value={formData.disabilityTypewantScribe}
                  onChange={(e) => {
                    handleInputChange(e);
                    checkErrorFn("disabilityTypewantScribe", e.target.value);
                  }}
                  onBlur={() =>
                    checkErrorFn(
                      "disabilityTypewantScribe",
                      formData["disabilityTypewantScribe"]
                    )
                  }
                  required
                  style={
                    fieldErrors?.["disabilityTypewantScribe"]?.errors?.length >
                      0 && fieldErrors?.["disabilityTypewantScribe"]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                >
                  <option value="">Select</option>
                  {options?.yesNoOptions?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {fieldErrors?.["disabilityTypewantScribe"]?.errors?.length >
                  0 &&
                  fieldErrors?.["disabilityTypewantScribe"]?.touched &&
                  fieldErrors?.["disabilityTypewantScribe"]?.errors.map(
                    (err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    )
                  )}
              </div>
            </Col> */}

            {/* Conditional Rendering: Show Physical Limitation only if 'Yes' is selected in 'Do You Want a Scribe?' */}
            {/* {formData.disabilityTypewantScribe === "Yes" && (
              <Col xs={12} md={6}>
                <div className="mb-1">
                  <label
                    className="form-label inputBoxHeadForm"
                    style={style.label}
                  >
                    Do You Have Physical Limitation?
                    <span className="mx-1 text-danger">*</span>
                  </label>
                  <select
                    name="disabilityTypephysicalLimitation"
                    value={formData.disabilityTypephysicalLimitation}
                    onChange={(e) => {
                      handleInputChange(e);
                      checkErrorFn(
                        "disabilityTypephysicalLimitation",
                        e.target.value
                      );
                    }}
                    onBlur={() =>
                      checkErrorFn(
                        "disabilityTypephysicalLimitation",
                        formData["disabilityTypephysicalLimitation"]
                      )
                    }
                    required
                    style={
                      fieldErrors?.["disabilityTypephysicalLimitation"]?.errors
                        ?.length > 0 &&
                      fieldErrors?.["disabilityTypephysicalLimitation"]?.touched
                        ? { ...style.input, ...style.errorBox }
                        : style.input
                    }
                  >
                    <option value="">Select</option>
                    {options?.yesNoOptions?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  {fieldErrors?.["disabilityTypephysicalLimitation"]?.errors
                    ?.length > 0 &&
                    fieldErrors?.["disabilityTypephysicalLimitation"]
                      ?.touched &&
                    fieldErrors?.[
                      "disabilityTypephysicalLimitation"
                    ]?.errors.map((err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    ))}
                </div>
              </Col>
            )} */}

            {/* File Upload Section */}
            <Col xs={12} md={12} id="personWithDisabilityFileUpload">
              <div className="mb-3">
                {formData.disabilityFiles.length > 0 && (
                  <div className="d-flex">
                    <label
                      className="form-label inputBoxHeadForm"
                      style={style.label}
                    >
                      Upload Documents
                      <span className="mx-1 text-danger">*</span>
                    </label>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "brown",
                        fontWeight: "bold",
                      }}
                    >
                      (Only PDF files that are under 2 MB in size are accepted.)
                    </div>
                  </div>
                )}

                {formData.disabilityFiles.map((fileObj, index) => (
                  <Row key={index} className="align-items-start mb-3">
                    {/* File Upload Button + Error */}
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column">
                        <input
                          type="file"
                          accept=".pdf"
                          required
                          onChange={(e) => handleFileChange(e, index)}
                          style={{ display: "none" }}
                          onBlur={() =>
                            checkErrorFn("disabilityFile", fileObj.file, index)
                          }
                          id={`disabilityFile_input_${index}`}
                        />
                        <button
                          type="button"
                          onClick={() =>
                            document
                              .getElementById(`disabilityFile_input_${index}`)
                              .click()
                          }
                          onBlur={() =>
                            checkErrorFn("disabilityFile", fileObj.file, index)
                          }
                
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            height: "37px",
                            fontSize: "12px",
                            cursor: "pointer",
                            border: "none",
                            backgroundColor:"#921d1e",
                              // fieldErrors?.[`disabilityFile_${index}`]?.errors
                              //   ?.length > 0
                              //   ? "#921d1e"
                              //   : "#f0f0f0",
                            color:"#fff",
                              // fieldErrors?.[`disabilityFile_${index}`]?.errors
                              //   ?.length > 0
                              //   ? "#fff"
                              //   : "#333",
                          }}
                        >
                          <span className="ps-1">Upload File</span>
                        </button>

                        {/* Upload Button Error Below */}
                        {fieldErrors?.[`disabilityFile_${index}`]?.errors?.map(
                          (err, errIdx) => (
                            <span
                              key={errIdx}
                              className="errorPresent"
                              style={style.errorSpan}
                            >
                              {err}
                            </span>
                          )
                        )}
                      </div>
                    </Col>

                    {/* File Name Input + Error */}
                    <Col xs={12} md={4}>
                      <div className="d-flex flex-column">
                        <input
                          type="text"
                          placeholder="Enter File Name"
                          value={fileObj.name}
                          onChange={(e) => handleFileNameChange(e, index)}
                          onBlur={() =>
                            checkErrorFn(
                              "disabilityFileName",
                              fileObj.name,
                              index
                            )
                          }
                          style={
                            fieldErrors?.["disabilityFileName"]?.errors
                              ?.length > 0 &&
                            fieldErrors?.["disabilityFileName"]?.touched
                              ? { ...style.input, ...style.errorBox }
                              : style.input
                          }
                        />
                        {/* File Name Input Error Below */}
                        {fieldErrors?.[
                          `disabilityFileName_${index}`
                        ]?.errors?.map((err, errIdx) => (
                          <span
                            key={errIdx}
                            className="errorPresent"
                            style={style.errorSpan}
                          >
                            {err}
                          </span>
                        ))}
                      </div>
                    </Col>

                    {/* File Actions */}
                    <Col
                      xs={12}
                      md={5}
                      className="d-flex align-items-center mt-2 mt-md-0"
                    >
                      {fileObj.file && (
                        <>
                          {/* PDF Icon Preview */}
                          <img
                            src={pdfIcon}
                            alt="PDF Preview"
                            style={{ width: "40px", cursor: "pointer" }}
                            onClick={() => setShowIframe(index)}
                            className="me-2"
                          />

                          {/* Verify Button or Verified Badge */}
                          {!fileObj.verified ? (
                            <Button
                              size="sm"
                              onClick={() => handleOpenVerificationModal(index)}
                              className="me-2"
                            >
                              Verify
                            </Button>
                          ) : (
                            <Badge
                              bg="success"
                              className="d-flex align-items-center me-2"
                            >
                              <FaCheckCircle size={"18"} className="me-1" />
                              Verified
                            </Badge>
                          )}

                          {/* Eye Icon */}
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => handleOpenVerificationModal(index)}
                            className="me-2"
                          >
                            <IoEyeOutline size={"20"} />
                          </Button>

                          {/* Delete Icon */}
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => removeFile(index)}
                          >
                            <MdDeleteOutline size={"20"} />
                          </Button>
                        </>
                      )}
                    </Col>
                  </Row>
                ))}

                {/* Add File Button */}
                <div className="text-end">
                  <Button
                    style={{ backgroundColor: "brown", borderColor: "brown" }}
                    onClick={addFile}
                  >
                    Add File
                  </Button>
                </div>
              </div>
            </Col>

            {/* PwBD Declaration */}
            {/* <Col xs={12} md={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "30px",
                }}
              >
                <input
                  type="checkbox"
                  id="declaration-checkbox"
                  name="pwbdDeclaration"
                  checked={formData?.pwbdDeclaration}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  onBlur={() =>
                    checkErrorFn("pwbdDeclaration", formData["pwbdDeclaration"])
                  }
                  style={{ marginRight: "10px" }}
                />
                <label
                  htmlFor="declaration-checkbox"
                  className="fw-bold"
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.5",
                    fontFamily: "'Roboto', sans-serif",
                    color: "black",
                  }}
                >
                  I confirm that I am a PwBD category candidate with a permanent
                  disability, and I fulfill the physical requirement standards
                  for the post as laid down in the advertisement. In case of any
                  discrepancy, my candidature is liable to be cancelled.
                </label>
              </div>
              {fieldErrors?.["pwbdDeclaration"]?.errors?.length > 0 &&
                fieldErrors?.["pwbdDeclaration"]?.touched &&
                fieldErrors?.["pwbdDeclaration"]?.errors.map((err, idx) => (
                  <span
                    key={idx}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </Col> */}
          </>
        )}
      </Row>

      {/* Modal for File Preview and Verification */}
      {showIframe !== null && (
        <Modal
          size="lg"
          show={showIframe !== null}
          onHide={() => setShowIframe(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Verify Document</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {formData.disabilityFiles[showIframe]?.file ? (
              <iframe
                src={formData.disabilityFiles[showIframe].file}
                width="100%"
                style={{ border: "none", height: "50vh" }}
                title="PDF Viewer"
              />
            ) : (
              <p>No file available for preview.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            {!formData.disabilityFiles[showIframe]?.verified && (
              <Button variant="primary" onClick={handleConfirmVerification}>
                Confirm Verification
              </Button>
            )}
            <Button variant="secondary" onClick={() => setShowIframe(null)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Initialize Toast Notifications */}
      {/* <ToastContainer /> */}
    </>
  );
};

export default PersonWithDisability;
